import useOrganization from '../../Hooks/useOrganization';
import { CustomFields, FieldDefinition } from '@/src/types';
import React from 'react';
import TextDisplay from './TextDisplay';
import TextAreaDisplay from './TextAreaDisplay';
import SelectDisplay from './SelectDisplay';
import CheckboxDisplay from './CheckboxDisplay';

interface Props {
    customInformation:CustomFields;
    type:"contact" | "company" | "address" | "ticket";
}

export default React.memo((props: Props) => {
    const org = useOrganization();
    const definitions = org.customFieldDefinition[props.type];
    if(definitions.length === 0){
        return null;
    }

    const renderDefinition = React.useCallback((definition:FieldDefinition) =>{
        const record = props.customInformation && props.customInformation[props.type] ? props.customInformation[props.type] as any : {};
        const fieldValue = record[definition.label] || "";
        
        if(definition.type === "text"){
            return (
                    <TextDisplay value={fieldValue} label={definition.label} />
            )
        }
        
        if(definition.type === "textarea"){
            return (
                    <TextAreaDisplay value={fieldValue} label={definition.label} />
            )
        }
        
        if(definition.type === "select"){
            return (
                <>
                    <SelectDisplay options={definition.options} value={fieldValue} label={definition.label}  />
                </>
            )
        }
        
        if(definition.type === "checkbox"){
            return (
                <>
                    <CheckboxDisplay value={fieldValue} label={definition.label} />
                </>
            )
        }
    },[props]);

    return (
        <>
        {definitions.map(renderDefinition)}
        </>
    )
})